// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/statistics_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { StatisticsService } from "./statistics_service_pb";

/**
 * @generated from rpc inventory.v1.StatisticsService.GetAlertsCountBySeverityTimeseries
 */
export const getAlertsCountBySeverityTimeseries = StatisticsService.method.getAlertsCountBySeverityTimeseries;

/**
 * @generated from rpc inventory.v1.StatisticsService.ListCompaniesWithMostAlerts
 */
export const listCompaniesWithMostAlerts = StatisticsService.method.listCompaniesWithMostAlerts;

/**
 * @generated from rpc inventory.v1.StatisticsService.GetCountCompaniesBySeverity
 */
export const getCountCompaniesBySeverity = StatisticsService.method.getCountCompaniesBySeverity;

/**
 * @generated from rpc inventory.v1.StatisticsService.DaysCompaniesInAssessmentRequired
 */
export const daysCompaniesInAssessmentRequired = StatisticsService.method.daysCompaniesInAssessmentRequired;

/**
 * @generated from rpc inventory.v1.StatisticsService.OngoingAssessmentsSummary
 */
export const ongoingAssessmentsSummary = StatisticsService.method.ongoingAssessmentsSummary;

/**
 * @generated from rpc inventory.v1.StatisticsService.GetCompaniesCompliances
 */
export const getCompaniesCompliances = StatisticsService.method.getCompaniesCompliances;

/**
 * @generated from rpc inventory.v1.StatisticsService.ListTopModelProviders
 */
export const listTopModelProviders = StatisticsService.method.listTopModelProviders;

/**
 * @generated from rpc inventory.v1.StatisticsService.ListThirdPartyCountsByAICapability
 */
export const listThirdPartyCountsByAICapability = StatisticsService.method.listThirdPartyCountsByAICapability;

/**
 * @generated from rpc inventory.v1.StatisticsService.ListThirdPartyCountsByAIPosture
 */
export const listThirdPartyCountsByAIPosture = StatisticsService.method.listThirdPartyCountsByAIPosture;

/**
 * @generated from rpc inventory.v1.StatisticsService.ListDiscoverySolutionCountsByAIPosture
 */
export const listDiscoverySolutionCountsByAIPosture = StatisticsService.method.listDiscoverySolutionCountsByAIPosture;

/**
 * @generated from rpc inventory.v1.StatisticsService.ListAIThirdPartyCountsByAssessmentScore
 */
export const listAIThirdPartyCountsByAssessmentScore = StatisticsService.method.listAIThirdPartyCountsByAssessmentScore;

/**
 * @generated from rpc inventory.v1.StatisticsService.ListAIThirdPartyAlertCountsBySeverity
 */
export const listAIThirdPartyAlertCountsBySeverity = StatisticsService.method.listAIThirdPartyAlertCountsBySeverity;
